import { Link } from "react-router-dom";
import { useSettings } from "../lib/store";
import { WhatsAppIcon, FlagChip } from "./icons";
import { waLink, MSG } from "../lib/whatsapp";

const MENU = [
  { to: "/destinations", label: "Destinations" },
  { to: "/land-arrangement", label: "Land Arrangement" },
  { to: "/private-trip", label: "Private Trip" },
  { to: "/corporate-group", label: "Corporate" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
  { to: "/faq", label: "FAQ" },
];

export default function Footer() {
  const { settings } = useSettings();
  const wa = waLink(settings, MSG.general);

  return (
    <footer className="bg-tosca-900 text-white">
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.svg" alt="Beyond Travel" className="h-12 w-12 rounded-xl" />
            <div>
              <p className="font-heading text-lg font-extrabold tracking-wide">
                BEYOND <span className="text-gold">TRAVEL</span>
              </p>
              <p className="text-[10px] uppercase tracking-[0.22em] text-tosca-200">Travel More, Explore More</p>
            </div>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-tosca-100/70">
            Land Arrangement internasional dan domestik: itinerary, hotel, transportasi lokal, guide, hingga local support sesuai paket.
          </p>
          <div className="mt-5 flex gap-3">
            <a href={wa} target="_blank" rel="noreferrer" className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition hover:bg-[#25D366]" aria-label="WhatsApp" data-testid="footer-wa-link">
              <WhatsAppIcon className="h-4 w-4" />
            </a>
            <a href="https://instagram.com/beyondtravel.co.id" target="_blank" rel="noreferrer" className="inline-flex h-10 items-center justify-center rounded-full bg-white/10 px-4 text-xs font-semibold transition hover:bg-gold hover:text-charcoal" aria-label="Instagram">
              Instagram
            </a>
            <a href="https://tiktok.com/@BeyondTourTravel" target="_blank" rel="noreferrer" className="inline-flex h-10 items-center justify-center rounded-full bg-white/10 px-4 text-xs font-semibold transition hover:bg-gold hover:text-charcoal" aria-label="TikTok">
              TikTok
            </a>
          </div>
        </div>

        <div>
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-gold">Menu</p>
          <ul className="mt-5 space-y-2.5">
            {MENU.map((m) => (
              <li key={m.to}>
                <Link to={m.to} className="text-sm text-tosca-100/80 transition hover:text-gold" data-testid={`footer-link-${m.to.slice(1)}`}>
                  {m.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-gold">Destinasi</p>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {["malaysia", "singapore", "thailand", "china", "egypt", "dubai", "turkey", "japan", "vietnam", "europe", "america"].map((s) => (
              <li key={s}>
                <Link to={`/destinations/${s}`} className="text-sm capitalize text-tosca-100/80 transition hover:text-gold">
                  {s === "dubai" ? "Dubai / UAE" : s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-gold">Contact</p>
          <ul className="mt-5 space-y-3 text-sm text-tosca-100/80">
            <li>
              <span className="block text-[11px] uppercase tracking-wider text-tosca-200/60">Website</span>
              <a href="https://beyondtravel.co.id" className="transition hover:text-gold">beyondtravel.co.id</a>
            </li>
            <li>
              <span className="block text-[11px] uppercase tracking-wider text-tosca-200/60">Instagram / TikTok</span>
              @beyondtravel.co.id · @BeyondTourTravel
            </li>
            <li>
              <span className="block text-[11px] uppercase tracking-wider text-tosca-200/60">WhatsApp</span>
              <a href={wa} target="_blank" rel="noreferrer" className="transition hover:text-gold" data-testid="footer-wa-number">
                {settings?.whatsapp_display || "+62 881-2551-877"}
              </a>
            </li>
            <li>
              <span className="block text-[11px] uppercase tracking-wider text-tosca-200/60">Email</span>
              <a href="mailto:info@beyondtravel.co.id" className="transition hover:text-gold">info@beyondtravel.co.id</a>
            </li>
            <li>
              <span className="block text-[11px] uppercase tracking-wider text-tosca-200/60">Alamat</span>
              Ruko U-Ville Avenue, Jl. Boulevard UPJ Ruko U-Ville A No.5, Sawah Baru, Ciputat, Tangerang Selatan, Banten 15413
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-tosca-100/60 sm:flex-row">
          <p>© 2026 Beyond Travel. All Rights Reserved.</p>
          <p>Travel More, Explore More</p>
        </div>
      </div>
    </footer>
  );
}
